var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.978516 1.99219C0.441406 1.99219 0.00195312 1.52344 0.00195312 0.996094C0.00195312 0.449219 0.431641 0 0.978516 0H19.2207C19.7773 0 20.2168 0.439453 20.2168 0.996094C20.2168 1.5332 19.7676 1.99219 19.2207 1.99219H0.978516ZM0.978516 6.50391C0.441406 6.50391 0.00195312 6.03516 0.00195312 5.49805C0.00195312 4.95117 0.431641 4.49219 0.978516 4.49219H19.2207C19.7773 4.49219 20.2168 4.94141 20.2168 5.49805C20.2168 6.04492 19.7676 6.50391 19.2207 6.50391H0.978516ZM0.978516 11.0059C0.441406 11.0059 0.00195312 10.5469 0.00195312 10C0.00195312 9.46289 0.431641 9.00391 0.978516 9.00391H19.2207C19.7773 9.00391 20.2168 9.45312 20.2168 10C20.2168 10.5469 19.7676 11.0059 19.2207 11.0059H0.978516Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.071d6e1fbeeb58b28be544bb3de2e7d7.svg";
export { ForwardRef as ReactComponent };